import { useCategoriesQuery } from 'hooks/useCategoriesQuery'
import { Media } from 'media'
import { ComponentType } from 'react'
import { CategoriesDesktop } from './categories-desktop'
import { CategoriesMobile } from './categories-mobile'

interface Props {
  zone: any
}

export const Categories: ComponentType<Props> = ({ zone }) => {
  const { data } = useCategoriesQuery({ variables: { query: { zone: zone.uuid } } })
  const categories = data?.categories.data ?? []

  return (
    <>
      <Media at="xs">
        <CategoriesMobile categories={categories} zone={zone} />
      </Media>
      <Media greaterThan="xs">
        <CategoriesDesktop categories={categories} zone={zone} />
      </Media>
    </>
  )
}
